export default __webpack_public_path__ + "static/article-why-financial-freedom-is-worth-the-effort-772bcdda6f7b06622e406848ba7db746.jpg";